import { QueryClient } from "@tanstack/react-query"
import { type GetServerSidePropsContext, type InferGetServerSidePropsType } from "next"
import { z } from "zod"
import { getStoryblokHeadlessLayout, getStoryblokLayout, StoryTemplate } from "@/features/storyblok"
import { withStoryProps } from "@/features/storyblok/server"
import { HeadlessSchema } from "@/schemas/queryParamsSchema"

export default function LandingPage({
    story,
    preview,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
    return (
        <StoryTemplate
            story={story}
            preview={preview}
        />
    )
}

LandingPage.getLayout = getStoryblokLayout
LandingPage.getHeadlessLayout = getStoryblokHeadlessLayout
LandingPage.messages = [...getStoryblokLayout.messages] as const

const ParamsSchema = z.object({
    ...HeadlessSchema.shape,
    landingId: z.string(),
})

export async function getServerSideProps(context: GetServerSidePropsContext) {
    const parsedParams = ParamsSchema.safeParse(context.query)
    const queryClient = new QueryClient()

    if (!parsedParams.success) {
        return { notFound: true }
    }

    return withStoryProps({
        slug: parsedParams.data.landingId,
        queryClient,
        context,
        intlNamespaces: LandingPage.messages,
        props: {
            headless: parsedParams.data.headless,
        },
    })
}
